import { v4 as uuidv4 } from "uuid";
export const generateStoragePath = (orderId: string) => {
  const uuid = uuidv4();
  return `/onco_emr/${orderId}/draft_submission/${uuid}.png`;
};
